export const PaymentModal = {
  position: 'fixed',
  top: '0',
  left: '0',
  width: '100vw',
  height: '100vh',
  background: 'rgba(0, 0, 0, 0.65)',
  display: 'flex',
  align: 'center center',
  zIndex: '1000',

  ModalContent: {
    flow: 'y',
    gap: 'A',
    padding: 'C',
    round: 'A',
    background: 'inkMid',
    border: '1px solid inkBorder',
    width: '480px',
    maxWidth: '90vw',
    maxHeight: '85vh',
    overflow: 'auto',

    ModalHeader: {
      flow: 'x',
      justifyContent: 'space-between',
      align: 'center flex-start',
      Title: { text: '{{ processPayment | polyglot }}', fontSize: 'B', fontWeight: '700', color: 'inkText' },
      CloseBtn: { tag: 'button', text: '\u2715', fontSize: 'A', background: 'none', border: 'none', color: 'inkMuted', cursor: 'pointer', onClick: (e, el, s) => s.root.update({ paymentModalOpen: false }) }
    },

    AmountSection: {
      flow: 'y',
      gap: 'Y',
      AmountLabel: { text: '{{ totalDue | polyglot }}', fontSize: 'Y', color: 'inkMuted', fontWeight: '600', textTransform: 'uppercase', letterSpacing: 'X' },
      AmountValue: { text: (el, s) => s.root.paymentAmount || '\u20BE0', fontSize: 'D', fontWeight: '800', color: 'inkText' },
      PartialPaymentRow: {
        flow: 'x',
        gap: 'Y',
        align: 'center flex-start',
        PartialLabel: { text: '{{ customAmount | polyglot }}', fontSize: 'Y', color: 'inkMuted', whiteSpace: 'nowrap' },
        PartialInput: {
          tag: 'input',
          type: 'text',
          placeholder: '{{ enterAmount | polyglot }}',
          padding: 'Y Z',
          round: 'Y',
          background: 'inkSurface',
          border: '1px solid inkBorder',
          color: 'inkText',
          fontSize: 'Z',
          flex: '1',
          outline: 'none',
          onChange: (e, el, s) => s.root.update({ paymentAmount: e.target.value })
        }
      }
    },

    Divider: { height: '1px', background: 'inkBorder' },

    MethodSection: {
      flow: 'y',
      gap: 'Z',
      MethodLabel: { text: '{{ paymentMethod | polyglot }}', fontSize: 'Y', color: 'inkMuted', fontWeight: '600', textTransform: 'uppercase', letterSpacing: 'X' },
      MethodOptions: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 'Y',

        CardOption: {
          flow: 'y',
          align: 'center center',
          gap: 'Y',
          padding: 'Z',
          round: 'Z',
          cursor: 'pointer',
          border: (el, s) => s.root.paymentMethod === 'card' ? '2px solid teal' : '1px solid inkBorder',
          background: (el, s) => s.root.paymentMethod === 'card' ? 'teal.15' : 'inkSurface',
          onClick: (e, el, s) => s.root.update({ paymentMethod: 'card' }),
          Icon: { text: '\uD83D\uDCB3', fontSize: 'B' },
          Label: { text: '{{ card | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkText' }
        },
        CashOption: {
          flow: 'y',
          align: 'center center',
          gap: 'Y',
          padding: 'Z',
          round: 'Z',
          cursor: 'pointer',
          border: (el, s) => s.root.paymentMethod === 'cash' ? '2px solid teal' : '1px solid inkBorder',
          background: (el, s) => s.root.paymentMethod === 'cash' ? 'teal.15' : 'inkSurface',
          onClick: (e, el, s) => s.root.update({ paymentMethod: 'cash' }),
          Icon: { text: '\uD83D\uDCB5', fontSize: 'B' },
          Label: { text: '{{ cash | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkText' }
        },
        BankOption: {
          flow: 'y',
          align: 'center center',
          gap: 'Y',
          padding: 'Z',
          round: 'Z',
          cursor: 'pointer',
          border: (el, s) => s.root.paymentMethod === 'bank' ? '2px solid teal' : '1px solid inkBorder',
          background: (el, s) => s.root.paymentMethod === 'bank' ? 'teal.15' : 'inkSurface',
          onClick: (e, el, s) => s.root.update({ paymentMethod: 'bank' }),
          Icon: { text: '\uD83C\uDFE6', fontSize: 'B' },
          Label: { text: '{{ bankTransfer | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkText' }
        },
        InstallmentOption: {
          flow: 'y',
          align: 'center center',
          gap: 'Y',
          padding: 'Z',
          round: 'Z',
          cursor: 'pointer',
          border: (el, s) => s.root.paymentMethod === 'installment' ? '2px solid teal' : '1px solid inkBorder',
          background: (el, s) => s.root.paymentMethod === 'installment' ? 'teal.15' : 'inkSurface',
          onClick: (e, el, s) => s.root.update({ paymentMethod: 'installment' }),
          Icon: { text: '\uD83D\uDCC5', fontSize: 'B' },
          Label: { text: '{{ installment | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkText' }
        }
      }
    },

    Divider2: { height: '1px', background: 'inkBorder' },

    BreakdownSection: {
      flow: 'y',
      gap: 'Y',
      BreakdownLabel: { text: '{{ breakdown | polyglot }}', fontSize: 'Y', color: 'inkMuted', fontWeight: '600', textTransform: 'uppercase', letterSpacing: 'X' },
      SubtotalRow: {
        flow: 'x', justifyContent: 'space-between',
        Label: { text: '{{ subtotal | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
        Value: { text: (el, s) => s.root.paymentAmount || '\u20BE0', fontSize: 'Y', fontWeight: '600', color: 'inkText' }
      },
      InsuranceRow: {
        flow: 'x', justifyContent: 'space-between',
        Label: { text: '{{ insuranceCoverage | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
        Value: { text: '\u20BE0', fontSize: 'Y', fontWeight: '600', color: 'green' }
      },
      PatientDueRow: {
        flow: 'x', justifyContent: 'space-between',
        Label: { text: '{{ patientDue | polyglot }}', fontSize: 'Z', fontWeight: '700', color: 'inkText' },
        Value: { text: (el, s) => s.root.paymentAmount || '\u20BE0', fontSize: 'Z', fontWeight: '700', color: 'inkText' }
      }
    },

    ProcessBtn: {
      tag: 'button',
      text: '{{ processPaymentBtn | polyglot }}',
      padding: 'Z A',
      round: 'A',
      background: 'teal',
      color: 'ink',
      fontSize: 'Z',
      fontWeight: '700',
      cursor: 'pointer',
      border: 'none',
      textAlign: 'center',
      width: '100%',
      onClick: (e, el, s) => s.root.update({ paymentModalOpen: false })
    },

    ReceiptPreview: {
      flow: 'y',
      gap: 'Y',
      padding: 'Z',
      round: 'Y',
      background: 'inkSurface',
      border: '1px dashed inkBorder',
      ReceiptTitle: { text: '{{ receiptPreview | polyglot }}', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' },
      ReceiptLine1: { text: (el, s) => `{{ method | polyglot }}: ${s.root.paymentMethod || '—'}`, fontSize: 'Y', color: 'inkMuted' },
      ReceiptLine2: { text: (el, s) => `{{ amount | polyglot }}: ${s.root.paymentAmount || '\u20BE0'}`, fontSize: 'Y', color: 'inkMuted' }
    }
  }
}
